export default function (Alpine) {
  Alpine.magic('maxMediaMatches', () => size => {
    const mql = window.matchMedia(`(width <= ${size})`)
    const data = Alpine.reactive({ matches: mql.matches })

    mql.addEventListener('change', event => {
      data.matches = event.matches
    })

    return data.matches
  })
}
